<script lang="ts" setup>
import { useIsProService } from "~/helpers/functions/IsProService";

import { parseBold } from "~/helpers/functions/TextUtils";
import arrow from "@/assets/img/ui-insurance/arrow.png";
import arrowVideo from "@/assets/videos/arrow.mp4";
const isProService = useIsProService();

const { animationEnabled } = useCustom();
const animation = ref(animationEnabled);
const router = useRouter();
const notRedirected: string[] = [
  "RESPONSABILITÉ CIVILE DÉCÉNALE",
  "FLOTTE AUTO",
  "MULTIRISQUE PROFESSIONNELLE",
  "RESPONSABILITÉ CIVILE PRO",
  "DOMMAGE OUVRAGE",
  "PRÉVOYANCE PRO",
  "PROTECTION JURIDIQUE PRO",
  "SANTÉ COLLECTIVE",
  "ASSURANCE AUTO PRO",
  "ASSURANCE VTC/TAXI",
  "MARCHANDISES TRANSPORTÉES",
];

const navigateToServices = () => {
  if (isProService.value && !notRedirected.includes(data.title)) {
    router.push(`/assurances/contactez-nous?assurance=${data.title}`);
  } else {
    window.open(data.url, "_blank");
  }
};
const { t } = useI18n();
const { data } = defineProps<{
  data: {
    title: string;
    url?: string;
    subTitle: string;
    button?: string;
    icon: string;
    items: {
      video: string;
      bg: string;
    }[];
  };
}>();
</script>
<template>
  <section>
    <div class="top">
      <div class="top-title">
        <div class="title-container">
          <img :src="data.icon" class="mobile" :alt="data.title" />
          <h1 class="title">
            <img :src="data.icon" class="desktop" :alt="data.title" />
            {{ data.title }}
          </h1>
        </div>
        <p class="underText"><slot name="underTitle"></slot></p>
      </div>
      <p class="subTitle" v-html="parseBold(data.subTitle)"></p>
    </div>
    <div class="middle">
      <div class="left">
        <CommonVideoWithPlaceholder
          :video-src="data.items[0].video"
          :placeholder="data.items[0].bg"
          class-video="video bg"
          class-placeholder="bg img"
          :alt="data.title"
          :is-playing="animation"
        />
      </div>
      <div class="right" :class="{ desktop: data.items.length <= 2 }">
        <CommonVideoWithPlaceholder
          :video-src="data.items[1].video"
          :placeholder="data.items[1].bg"
          class-video="video bg"
          class-placeholder="bg img"
          :alt="data.title"
          :is-playing="animation"
        />
      </div>
    </div>
    <div v-if="data.button" class="bottom">
      <CommonVideoWithPlaceholder
        :video-src="arrowVideo"
        :placeholder="arrow"
        class-video="left-arrow"
        class-placeholder="left-arrow left-arrow-img"
        :is-playing="animation"
        :alt="t('alt.leftArrow')"
      />
      <button class="purple-button main-button" @click="navigateToServices">
        <span class="text">
          {{ data.button }}
        </span>
        <span id="arrow" class="icon">
          <img
            v-if="!isProService"
            src="@/assets/img/home/arrow.svg"
            :alt="t('alt.arrow')"
          />
          <img
            v-if="isProService"
            src="@/assets/img/home/blue-arrow.svg"
            :alt="t('alt.arrow')"
          />
        </span>
      </button>
      <CommonVideoWithPlaceholder
        :video-src="arrowVideo"
        :placeholder="arrow"
        class-video="right-arrow"
        class-placeholder="right-arrow right-arrow-img"
        :is-playing="animation"
        :alt="t('alt.leftArrow')"
      />
    </div>
    <slot name="button"></slot>
    <div v-if="data.items.length > 2" class="bottom-img">
      <div class="bottom-left">
        <CommonVideoWithPlaceholder
          :video-src="data.items[2].video"
          :placeholder="data.items[2].bg"
          class-video="video bg"
          class-placeholder="bg img"
          :alt="data.title"
          :is-playing="animation"
        />
      </div>
      <div class="bottom-right">
        <CommonVideoWithPlaceholder
          :video-src="data.items[3].video"
          :placeholder="data.items[3].bg"
          class-video="video bg"
          class-placeholder="bg img"
          :alt="data.title"
          :is-playing="animation"
        />
      </div>
    </div>
    <div v-if="data.items.length <= 2" class="bottom-img mobile">
      <div class="bottom-left">
        <CommonVideoWithPlaceholder
          :video-src="data.items[1].video"
          :placeholder="data.items[1].bg"
          class-video="video bg"
          class-placeholder="bg img"
          :is-playing="animation"
        />
      </div>
    </div>
  </section>
</template>
<style scoped>
.mobile {
  display: none;
}
/* top */
.top {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}
.top-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.5rem;
  justify-content: center;
}
.title-container {
  display: flex;
  align-items: center;
}
h1 {
  gap: 0.5rem;
  font-size: clamp(34px, 5vw, 75px);
  line-height: clamp(41px, 5vw, 102px);
  text-align: center;
  /* margin-bottom: 0; */
}
.title-container img {
  /* gap: 1.5rem; */
  width: clamp(34px, 4vw, 62px);
  height: clamp(34px, 4vw, 62px);
  position: relative;
  top: 1.5px;
  right: 15px;
}
.underText {
  position: absolute;
  /* top: calc(50% - clamp(180px, 18vw, 330px)); */

  text-align: center;
  /* font: normal normal normal 9.3rem/9rem "Gilmer Outline"; */
  font: normal normal normal clamp(60px, 8vw, 150px) / clamp(59px, 6.6vw, 127px)
    "Gilmer Outline";

  letter-spacing: 0;
  color: var(--vt-c-purple);
  text-shadow: inset 0 3px 6px var(--vt--c-deep-black);
  text-transform: uppercase;
  opacity: 0.1;
}
.subTitle {
  width: 50%;
  position: relative;
  top: clamp(-90px, -6vw, -40px);
  text-align: center;
  font-family: "Gilmer Regular";
  font-size: 22px;
  line-height: 29px;
}
/* middle */
section {
  position: relative;
}
.middle {
  top: 150px;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left,
.right {
  z-index: -1;
}
.left,
.bottom-left {
  margin-left: 2vw;
}

::v-deep(.bg) {
  width: 450px;
  height: 350px;
  object-fit: contain;
}

.bottom-img {
  top: 480px;
  z-index: -2;
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
/* bottom  */
.bottom {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: fit-content;
  margin: auto;
  margin-top: -1.5rem;
  /* margin-top: -18vw; */
}
::v-deep(.left-arrow),
::v-deep(.right-arrow) {
  width: clamp(58px, 6vw, 101px);
  height: clamp(66px, 6.5vw, 116px);
  z-index: -1;
  position: relative;

  /* position: absolute; */
}
::v-deep(.left-arrow) {
  top: clamp(5px, 1vw, 20px);
  rotate: 120deg;
}
::v-deep(.left-arrow-img) {
  rotate: unset;
}
::v-deep(.right-arrow) {
  transform: rotate(-60deg);

  bottom: clamp(5px, 1vw, 20px);
}
::v-deep(.right-arrow-img) {
  transform: rotate(180deg);
}
.purple-button {
  z-index: 99;
  margin: auto;
  /* margin-top: 5rem; */
  background: var(--vt-c-purple) 0% 0% no-repeat;
  font-family: "Gilmer Bold";
  position: relative;
  font-size: clamp(14px, 1.5vw, 22px);
  color: var(--vt-c-white);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 1rem;
  z-index: 2;
  transition: all 0.3s ease;
  border-radius: 50px;
  width: clamp(337px, 36vw, 489px);
  height: clamp(51px, 6vw, 71px);
}

.purple-button:hover {
  cursor: pointer;
  background-color: #441cd0;
  box-shadow: 0 0 90px #441cd0;
}
.text {
  padding-right: 7%;
}
.purple-button:hover .text {
  color: var(--vt-c-white);
}
.purple-button .icon {
  position: absolute;
  z-index: 2;
  height: clamp(36px, 4.5vw, 51px);
  width: clamp(36px, 4.5vw, 51px);
  right: 0.3rem;
  border-radius: 50%;
  background-color: var(--vt-c-white);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s ease;
}
#arrow img {
  height: 70%;
  transition: 0.3s ease;
}
.purple-button:hover #arrow img {
  transform: rotate(90deg);
}
.mobile {
  display: none;
}
@media screen and (max-width: 1800px) {
  .bottom {
    margin-top: -4.55rem;
  }
}
@media screen and (max-width: 1600px) {
  .left,
  .bottom-left {
    margin-left: 0vw;
  }
  .bottom {
    margin-top: -3rem;
  }

  .subTitle {
    width: 60%;
  }

  ::v-deep(.bg) {
    width: 451px;
    height: 300px;
  }
}
@media screen and (max-width: 1500px) {
  ::v-deep(.bg) {
    width: 300px;
    height: 300px;
  }
  .text {
    padding-right: 10%;
  }
}

@media screen and (max-width: 1254px) {
  .subTitle {
    width: 50%;
  }
  .bottom-img {
    top: 400px;
  }
  ::v-deep(.bg) {
    height: 220px;
  }
  .left,
  .bottom-left {
    margin-left: 0vw;
  }
  .title-container {
    padding: 1rem 2rem;
  }
  .bottom {
    margin-top: -2.4rem;
  }
}
@media screen and (max-width: 1124px) {
  .middle {
    top: 180px;
  }
  .bottom-img {
    top: 470px;
  }
}
@media screen and (max-width: 960px) {
  .bottom-img,
  .middle {
    position: unset;
    z-index: unset;
    justify-content: space-around;
  }
  .middle {
    margin-top: -6rem;
  }
  .bottom {
    margin-top: 2rem;
    margin-bottom: 20px;
  }
  .top-title {
    margin-top: -3.5rem;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
}
@media screen and (max-width: 780px) {
  section {
    overflow: hidden;
  }
  .mobile {
    display: flex;
  }
  .desktop {
    display: none;
  }

  h1 {
    font-size: 34px;
    line-height: 41px;

    gap: 2rem;
  }
  .title-container img {
    position: relative;
    right: 8px;
    width: 35px;
    height: 35px;
    top: unset;
  }
  .underText {
    line-height: 59px;
    font-size: 60px;
  }
  .subTitle {
    width: 95%;
    font-size: 17px;
  }
  .middle {
    margin-top: -4.5rem;
    justify-content: space-around;
  }
  .purple-button {
    /* width: 90%; */
    height: 51px;
    /* max-width: 300px; */
    font-size: 14px;
  }
  ::v-deep(.right-arrow),
  ::v-deep(.left-arrow) {
    width: 58px;
    height: 66px;
    /* margin: 2.5rem 1.5rem; */
  }
  ::v-deep(.bg) {
    width: 181px;
    height: 150px;
  }
  .right {
    margin-top: 0vw;
  }
  .bottom {
    margin-top: 0;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 500px) {
  .bottom {
    width: 100%;
    padding: 0;
  }
  ::v-deep(.left-arrow),
  ::v-deep(.right-arrow) {
    width: 46px;
    height: 49px;
  }
  ::v-deep(.left-arrow) {
    left: -5px;
  }
  ::v-deep(.right-arrow) {
    right: -5px;
  }
}
/*
@media screen and (max-width: 1124px) {
} */
</style>
